<template>
  <b-container fluid class="complex-filter-frame">
    <b-row>
      <b-col sm="12" class="text-left">
        <h1>Felhasználók</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group label-for="filter-input">
          <b-form-input
            @update="onNameChanged"
            id="filter-name-input"
            :value="name"
            type="search"
            placeholder="Keresés"
            class="search-box"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        aria-controls="users-table"
      ></b-pagination>
    </b-row>
    <b-row>
      <b-table
        @filtered="onFiltered"
        :items="list"
        :fields="fields"
        :filter="name"
        :v-if="list.length > 0"
        id="users-table"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template #cell(role)="row">
          <div id="label-1">{{ row.item.role.name }}</div>
        </template>
        <template #cell(actions)="row"><b-button @click="openEditUser(row.item)">Módosítás</b-button> </template>
      </b-table>
    </b-row>

    <b-modal ref="my-modal" title="Felhasználó módosítása">
      <div class="d-block text-center" v-if="selectedUser !== undefined">
        <b-row>
          <b-col md="12">
            <strong>{{ selectedUser.fullName }}</strong>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-dropdown :text="`Válasszon ki egy jogosultság kört`">
              <b-dropdown-item
                v-for="(actualRole, index) in roles"
                @click="onSelectedRoleClick(actualRole)"
                :key="`dropdown-${index}`"
              >
                {{ actualRole.name + ' jogosultság' }}</b-dropdown-item
              >
            </b-dropdown>
            <div>
              {{ selectedRoleName }}
            </div>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <b-button size="sm" variant="success" @click="editUser()">
          Mentés
        </b-button>
        <b-button size="sm" variant="danger" @click="closeModal()">
          Bezárás
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import * as UserApi from '../api/user'
export default {
  name: 'AccessManagement',
  created: async function() {
    await this.fetchRoles()
    await this.fetchList()
  },
  data: function() {
    return {
      perPage: 5,
      currentPage: 1,
      totalRows: 0,
      list: [],
      roles: [],
      selectedUser: undefined,
      selectedRole: undefined,
      selectedRoleName: '',
      fields: [
        {
          key: 'fullName',
          label: 'Név'
        },
        { key: 'email', label: 'E-mail' },
        {
          key: 'role',
          label: 'Szerepkör'
        },
        { key: 'actions', label: '' }
      ],
      name: ''
    }
  },
  methods: {
    openEditUser: function(user) {
      this.selectedUser = { ...user }
      this.selectedRoleName = user.role.name
      this.$refs['my-modal'].show()
    },
    onNameChanged: function(value) {
      this.name = value
    },
    closeModal: function() {
      this.$refs['my-modal'].hide()
    },
    fetchRoles: async function() {
      this.roles = await UserApi.getRoles()
    },
    fetchList: async function() {
      this.list = []
      const users = await UserApi.listUsers()
      this.totalRows = users.length
      this.list = users
    },
    onSelectedRoleClick(actualRole) {
      this.selectedRole = actualRole
      this.selectedRoleName = actualRole.name
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    editUser: async function() {
      await UserApi.patchUser(this.selectedUser._id, this.selectedRole._id)
      await this.fetchList()
      this.$refs['my-modal'].hide()
      this.$store.dispatch('notify', {
        newNotification: { type: 'success', message: 'Felhasználó sikeressen módosítva' }
      })
    }
  }
}
</script>
<style scoped></style>
